module.exports = __webpack_public_path__ + "img/mark.fab08696.png";